module.exports = __webpack_public_path__ + "2614243298eb8478c54249cdacc5d9b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/blocks.png
// module id = 3022
// module chunks = 0